import {DEFAULT_PATHS} from 'config.js';

import {lazy} from 'react';

const appRoot = DEFAULT_PATHS.APP.endsWith('/') ? DEFAULT_PATHS.APP.slice(1, DEFAULT_PATHS.APP.length) : DEFAULT_PATHS.APP;

const Students = {
	Students: lazy(() => import('./views/students/Students')),
};

const Overview = {
	Overview: lazy(() => import('./views/overview/Overview')),
};

const Lectures = {
	Lectures: lazy(() => import('./views/lectures/Lectures')),
	LectureDates: lazy(() => import('./views/lectures/LectureDates')),
};

const Malzama = {
	Malzama: lazy(() => import('./views/malzama/Malzama')),
};

const Staff = {
	Staff: lazy(() => import('./views/staff/Staff')),
};

const GeneralExams = {
	GeneralExams: lazy(() => import('./views/generalExams/GeneralExams')),
	GeneralExamsDates: lazy(() => import('./views/generalExams/GeneralExamDates')),
};


const routesAndMenuItems = {
	mainMenuItems: [
		{
			path: DEFAULT_PATHS.APP,
			exact: true,
			redirect: true,
			to: `${appRoot}/overview`,
			protected: true,
		},
		{
			path: `${appRoot}/overview`,
			label: 'menu.overview',
			icon: 'dashboard-1',
			protected: true,
			component: Overview.Overview,
		},
		{
			path: `${appRoot}/students`,
			label: 'menu.students',
			icon: 'user',
			protected: true,
			component: Students.Students,
		},
		{
			path: `${appRoot}/lectures`,
			label: 'menu.lectures',
			icon: 'content',
			protected: true,
			subs: [
				{
					path: `/lectures`,
					label: 'menu.lectures',
					icon: 'acorn',
					protected: true,
					component: Lectures.Lectures,
				},
				{
					path: `/lectureDates`,
					label: 'menu.lectureDates',
					icon: 'acorn',
					protected: true,
					component: Lectures.LectureDates,
				},
			]
		},
		{
			path: `${appRoot}/books`,
			label: 'menu.malzama',
			icon: 'book',
			protected: true,
			component: Malzama.Malzama,
		},
		{
			path: `${appRoot}/general-exams`,
			label: 'menu.generalExams',
			icon: 'quiz',
			protected: true,
			subs: [
				{
					path: `/exams`,
					label: 'menu.generalExams',
					icon: 'acorn',
					protected: true,
					component: GeneralExams.GeneralExams,
				},
				{
					path: `/dates`,
					label: 'menu.mainGeneralExams',
					icon: 'acorn',
					protected: true,
					component: GeneralExams.GeneralExamsDates,
				},
			]
		},
		{
			path: `${appRoot}/staff`,
			label: 'menu.staff',
			icon: 'support',
			protected: true,
			component: Staff.Staff,
		},
	],
	sidebarItems: [],
};
export default routesAndMenuItems;
